import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import PriceOffsetPage from './pages/PriceOffset';
import PriceSimulationPage from './pages/PriceSimulation';
import Login from './pages/Login';
import AuthRoute from './components/AuthRoute';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <AuthRoute>
              <MainLayout>
                <Routes>
                  <Route path="price-offset" element={<PriceOffsetPage />} />
                  <Route path="price-simulation" element={<PriceSimulationPage />} />
                  <Route path="" element={<Navigate to="price-offset" replace />} />
                </Routes>
              </MainLayout>
            </AuthRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
